// Greek
export const el = {
    weeklyRewards: 'Εβδομαδιαίες ανταμοιβές σε',
    days: 'ημέρες',
    hours: 'ώρες',
    minutes: 'λεπτά',
    seconds: 'δευτ',
    authenticating: 'Έλεγχος ταυτότητας',
    verifyWallet: 'Παρακαλώ περιμένετε ενώ επαληθεύουμε το πορτοφόλι σας',
    authRequired: 'Απαιτείται έλεγχος ταυτότητας',
    authFailed: 'Ο έλεγχος ταυτότητας απέτυχε. Παρακαλώ δοκιμάστε ξανά.',
    points: 'Πόντοι',
    rank: 'Κατάταξη',
    of: 'από',
    players: 'παίκτες',
    weeklyTopPlayers: 'Κορυφαίοι παίκτες της εβδομάδας',
    thisWeekLeaderboard: 'Πίνακας κατάταξης αυτής της εβδομάδας',
    rankingsReset: 'Η κατάταξη μηδενίζεται κάθε Κυριακή τα μεσάνυχτα UTC',
    yourPoints: 'Οι πόντοι σας',
    dailyRewardAvailable: 'Διαθέσιμη ημερήσια ανταμοιβή!',
    nextClaimAvailable: 'Επόμενη διεκδίκηση διαθέσιμη σε:',
    claimDailyReward: 'Διεκδικήστε την ημερήσια ανταμοιβή',
    claiming: 'Διεκδίκηση...',
    multiplier: 'Πολλαπλασιαστής',
    bonusPointsMultiplier: 'Πολλαπλασιαστής πόντων μπόνους',
    outOf: 'από',
    loading: 'Φόρτωση...',
    errorLoading: 'Σφάλμα φόρτωσης',
    noEntries: 'Δεν υπάρχουν καταχωρήσεις',
    leaderboard: 'Πίνακας κατάταξης',
    tasks: 'Εργασίες',
    rules: 'Κανόνες',
    profile: 'Προφίλ',
    comingSoon: 'Έρχεται σύντομα...',
    completedTasks: 'Ολοκληρωμένες εργασίες',
    dailyRewardsClaimed: 'Διεκδικημένες ημερήσιες ανταμοιβές',
    times: 'φορές',
    recentActivity: 'Πρόσφατη δραστηριότητα',
    noRewardsClaimed: 'Δεν έχουν διεκδικηθεί ανταμοιβές ακόμα',
    dailyReward: 'Ημερήσια ανταμοιβή',
    howItWorks: 'Πώς λειτουργεί',
    welcomeMessage:
        'Καλώς ήρθατε στο Coinomi Rewards! Κερδίστε πόντους ολοκληρώνοντας διάφορες εργασίες και ανεβείτε στην κατάταξη.',
    dailyRewardsTitle: 'Ημερήσιες ανταμοιβές',
    dailyRewardsRules: [
        'Διεκδικήστε την ημερήσια ανταμοιβή σας κάθε 24 ώρες',
        'Κάθε διεκδίκηση δίνει 100 πόντους',
        'Οι πόντοι πολλαπλασιάζονται με τον πολλαπλασιαστή σας',
    ],
    multiplierBonusesTitle: 'Μπόνους πολλαπλασιαστή',
    multiplierBonusesRules: [
        'Ξεκινήστε με 1x πολλαπλασιαστή',
        'Συνδέστε το Telegram για +10% μπόνους',
        'Επαληθεύστε το email για +10% μπόνους',
        'Τα μπόνους συσσωρεύονται για μέγιστες ανταμοιβές',
    ],
    leaderboardTitle: 'Πίνακας κατάταξης',
    leaderboardRules: [
        'Ανταγωνιστείτε με άλλους παίκτες',
        'Η κατάταξη ενημερώνεται σε πραγματικό χρόνο',
        'Οι κορυφαίοι παίκτες λαμβάνουν ειδικές ανταμοιβές',
    ],
    boostEarningsTitle: 'Αυξήστε τα κέρδη σας',
    boostEarningsRules: [
        'Ολοκληρώστε προκλήσεις για μπόνους',
        'Συμμετάσχετε στην κοινότητά μας στο Telegram',
        'Παραμείνετε ενεργοί για μέγιστες ανταμοιβές',
    ],
    challenges: 'Προκλήσεις',
    telegramChallenge: 'Πρόκληση Telegram',
    emailChallenge: 'Πρόκληση Email',
    connectTelegram: 'Σύνδεση Telegram',
    shareEmail: 'Κοινοποίηση email',
    telegramSuccess: '🎉 Συγχαρητήρια! Τώρα λαμβάνετε μόνιμο 10% μπόνους σε όλες τις ανταμοιβές!',
    telegramPrompt:
        'Συνδέστε τον λογαριασμό σας στο Telegram για να λάβετε μόνιμο 10% μπόνους σε όλες τις ανταμοιβές!',
    emailSuccess: '🎉 Συγχαρητήρια! Τώρα λαμβάνετε μόνιμο 10% μπόνους σε όλες τις ανταμοιβές!',
    emailPrompt:
        'Κοινοποιήστε το email σας για να λάβετε μόνιμο 10% μπόνους σε όλες τις ανταμοιβές!',
    connectEmail: 'Σύνδεση email',
    cancel: 'Ακύρωση',
    emailPrivacy:
        'Χρησιμοποιούμε το email σας μόνο για σημαντικές ενημερώσεις και ειδοποιήσεις ανταμοιβών.',
    connectYourEmail: 'Συνδέστε το email σας',
    emailBonus: '🎉 Λάβετε μόνιμο 10% μπόνους σε όλες τις ανταμοιβές συνδέοντας το email σας!',
    enterValidEmail: 'Παρακαλώ εισάγετε έγκυρη διεύθυνση email',
    emailAddress: 'Διεύθυνση email',
    errorSavingEmail: 'Σφάλμα κατά την αποθήκευση του email. Παρακαλώ δοκιμάστε ξανά.',
    claimButton: 'Διεκδίκηση',
    earnedReward: 'Κερδισμένη ανταμοιβή',
    rewardValue: '{{amount}} Πόντοι',
    claimingReward: 'Διεκδίκηση...',
    claimSuccess: 'Επιτυχής διεκδίκηση {{amount}} πόντων!',
    claimError: 'Η διεκδίκηση απέτυχε. Παρακαλώ δοκιμάστε ξανά.',
    privacyDisclaimer:
        'Η Coinomi δεν συλλέγει προσωπικά δεδομένα· ένα σύστημα τρίτου μέρους διαχειρίζεται με ασφάλεια τους πόντους και τις κοινωνικές συνδέσεις.',
    streakBonus: 'Μπόνους σερί',
    streakDays: '{{days}}/5 Ημέρες',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Επιπλέον',
    streakDescription: 'Διεκδικήστε 5 συνεχόμενες ημέρες για μέγιστο μπόνους',
    streakToday: 'Σήμερα',
    streakMissed: 'Χάθηκε',
    streakComplete: 'Ολοκληρώθηκε',
    streakActive: 'Ενεργό σερί',
    streakLost: 'Χαμένο σερί',
    streakNext: 'Επόμενο',
    home: 'Αρχική',
    currentStreak: 'Τρέχον σερί',
    totalClaims: 'Συνολικές διεκδικήσεις',
    userStats: 'Τα στατιστικά σας',
    referrals: 'Παραπομπές',
    referralProgram: 'Πρόγραμμα παραπομπών',
    howReferralWorks: 'Πώς λειτουργούν οι παραπομπές:',
    referralSteps: [
        'Μοιραστείτε τον σύνδεσμο παραπομπής σας με φίλους',
        'Όταν εγγραφούν μέσω του συνδέσμου σας, γίνονται παραπομπές σας',
        'Κερδίστε πόντους μπόνους για κάθε ενεργή παραπομπή',
        'Παρακολουθήστε τις παραπομπές και τα κέρδη σας εδώ',
    ],
    referralRewards: 'Πόντοι παραπομπών απονέμονται:',
    referralBonuses: [
        '100 πόντοι ανά παραπομπή',
        '10% όλων των πόντων που κερδίζει η παραπομπή σας',
    ],
    yourReferralLink: 'Ο σύνδεσμος παραπομπής σας',
    copyToClipboard: 'Αντιγραφή στο πρόχειρο',
    linkCopied: 'Ο σύνδεσμος αντιγράφηκε στο πρόχειρο!',
    totalReferrals: 'Συνολικές παραπομπές',
    yourReferralCode: 'Ο κωδικός παραπομπής σας',
    referralCodeCopied: 'Ο κωδικός παραπομπής αντιγράφηκε!',
    editReferralCode: 'Επεξεργασία κωδικού παραπομπής',
    editReferralCodeInstructions:
        'Επιλέξτε νέο κωδικό παραπομπής. Πρέπει να έχει τουλάχιστον 5 χαρακτήρες και μπορεί να περιέχει γράμματα και αριθμούς.',
    newReferralCode: 'Νέος κωδικός παραπομπής',
    referralCodeRequirements: 'Ελάχιστο 5 χαρακτήρες, μόνο γράμματα και αριθμοί',
    updating: 'Ενημέρωση...',
    update: 'Ενημέρωση',
    referralCodeTaken: 'Αυτός ο κωδικός παραπομπής χρησιμοποιείται ήδη',
    haveReferralCode: 'Έχετε κωδικό παραπομπής;',
    enterReferralCodePrompt:
        'Εάν κάποιος σας παρέπεμψε, εισάγετε τον κωδικό τους εδώ για να συνδέσετε τους λογαριασμούς.',
    enterReferralCode: 'Εισάγετε κωδικό παραπομπής',
    enterReferralCodeInstructions: 'Εισάγετε τον κωδικό παραπομπής που μοιράστηκε μαζί σας.',
    referralCode: 'Κωδικός παραπομπής',
    referralCodeFormat: 'Μόνο γράμματα και αριθμοί',
    submitting: 'Υποβολή...',
    submit: 'Υποβολή',
    enterCode: 'Εισάγετε κωδικό',
    pleaseAddtoken: 'Παρακαλώ προσθέστε την παράμετρο token στο URL',
    authenticationError: 'Παρουσιάστηκε σφάλμα κατά τον έλεγχο ταυτότητας',
    noUserFound: 'Δεν βρέθηκε χρήστης',
    userNotFoundMessage: 'Δεν είναι δυνατή η εύρεση δεδομένων χρήστη',
    backToHome: 'Επιστροφή στην αρχική',
    retry: 'Δοκιμάστε ξανά',
    baseMultiplier: 'Βασικός πολλαπλασιαστής',
    telegramBonus: 'Μπόνους Telegram',
    referralChallenge: 'Πρόκληση παραπομπών',
    referralChallengePrompt:
        'Προσκαλέστε φίλους και κερδίστε πόντους μπόνους! Λάβετε 100 πόντους για κάθε παραπομπή συν 10% των κερδών τους.',
    startReferring: 'Ξεκινήστε τις παραπομπές',
    referralSuccess:
        '🎉 Συγχαρητήρια! Έχετε παραπέμψει επιτυχώς χρήστες και κερδίζετε πόντους μπόνους!',
    unranked: 'Χωρίς κατάταξη',
    noPlayersYet: 'Γίνετε ο πρώτος που θα συμμετάσχει!',
    shareVia: 'Κοινοποίηση μέσω',
    shareOn: 'Κοινοποίηση στο {{network}}',
    shareInviteText:
        '🚀 Κερδίζω δωρεάν κρυπτονομίσματα με το @CoinomiWallet!\n\nΚατεβάστε το Coinomi από το coinomi.com/downloads και εισάγετε τον κωδικό παραπομπής μου {{referralCode}} για να λάβετε μπόνους όταν συμμετάσχετε στο #Coinomi Rewards στην εφαρμογή.',
    yourStatsThisWeek: 'Τα στατιστικά σας αυτήν την εβδομάδα',
    pointsMultiplier: 'Πολλαπλασιαστής πόντων',
    yourRank: 'Η κατάταξή σας',
    rewards: 'Ανταμοιβές',
    daily: 'Ημερήσια',
    weekly: 'Εβδομαδιαία',
    claimRewards: 'Διεκδίκηση ανταμοιβών',
    copy: 'Αντιγραφή',
    // Twitter Challenge
    twitterChallenge: 'Πρόκληση Twitter',
    connectTwitter: 'Σύνδεση Twitter',
    twitterSuccess: '🎉 Συγχαρητήρια! Τώρα λαμβάνετε 10% μόνιμο μπόνους σε όλες τις ανταμοιβές!',
    twitterPrompt:
        'Συνδέστε τον λογαριασμό σας στο Twitter για να λάβετε 10% μόνιμο μπόνους σε όλες τις ανταμοιβές!',
    pleaseAddUserId: 'Please add a userId parameter to the URL',
    emailChallengePrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    emailChallengeSuccess:
        '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    followKoalaWalletChallenge: 'Follow @coinomiWallet on Twitter to support us!',
    twitterAuthSuccessTitle: 'Twitter Connected Successfully!',
    twitterAuthSuccessMessage:
        'You have successfully connected your Twitter account. You can now continue using the app.',
    continueToApp: 'Continue to App',
    twitter_like: 'Liked a tweet',
    twitter_retweet: 'Retweeted a tweet',
    disconnect: 'Αποσύνδεση',
    followCoinomiWallet: 'Ακολούθησε το @coinomiWallet στο Twitter για να μας υποστηρίξεις!',
    connectedBonus: '🎉 Συνδέθηκε! Τώρα λαμβάνετε μόνιμο μπόνους 10% σε όλες τις ανταμοιβές!',
};
